var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.8169 17.1834C21.5729 17.4275 21.1771 17.4275 20.9331 17.1834L12 8.25034L3.06694 17.1834C2.82286 17.4275 2.42714 17.4275 2.18306 17.1834C1.93898 16.9393 1.93898 16.5436 2.18306 16.2995L11.1161 7.3665C11.1161 7.36647 11.1161 7.36644 11.1162 7.36641C11.2322 7.25027 11.3699 7.15813 11.5216 7.09526C11.6732 7.03237 11.8358 7 12 7C12.1642 7 12.3268 7.03237 12.4784 7.09526C12.6301 7.15813 12.7678 7.25027 12.8838 7.36641C12.8839 7.36644 12.8839 7.36647 12.8839 7.3665L21.8169 16.2995C22.061 16.5436 22.061 16.9393 21.8169 17.1834Z",
  fill: "#06262D"
})));
export { SvgChevronUp as ReactComponent };
export default __webpack_public_path__ + "images/chevron-up.svg";